import styled from "@emotion/styled";
import { useMemo, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useSingleton } from "../../other/injection";
import {
    RouteStore,
    pathToHref,
    getTestId
} from "../../other/navigationAndRouting/RouteStore";
import { Tabs, ITab } from "../../uiLibrary/tabs/Tabs";
import { observer } from "mobx-react-lite";

export const TabbedRoutesPageWrapper = observer(
    (props: { tabsTestId: string; children: ReactNode }) => {
        const location = useLocation();
        const routeStore = useSingleton(RouteStore);

        const currentRoute = routeStore.getRouteByPath(location.pathname);

        const topAncestor = routeStore.getTopAncestor(currentRoute, undefined);

        const currentAncestor = routeStore.getTopAncestor(
            currentRoute,
            topAncestor
        );

        const tabRoutes = routeStore.getChildrenMenuRoutes(topAncestor);

        const tabs = useMemo(
            () =>
                tabRoutes.map(
                    (x): ITab => ({
                        title: routeStore.getRouteTitle(x) ?? "",
                        href: pathToHref(x.path ?? ""),
                        testId: getTestId(x),
                        isSelected: x === currentAncestor
                    })
                ),
            [currentAncestor, tabRoutes, routeStore]
        );

        return (
            <Container>
                {tabs.length > 1 && (
                    <TopNav>
                        <Tabs tabs={tabs} testId={props.tabsTestId} />
                    </TopNav>
                )}
                <Page>{props.children}</Page>
            </Container>
        );
    }
);

const Container = styled("div")({
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column"
});

const TopNav = styled("div")(props => ({
    flexShrink: 0,
    height: 50,
    backgroundColor: props.theme.brandMedium,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
}));

const Page = styled("div")({
    flexGrow: 1,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    overflow: "auto"
});
